<template>
  <el-dialog custom-class="dialog-modal-permission" :model-value="flagVisible" width="770px" :before-close="handleClose">
    <div class="modal-permission">
      <div class="modal-p-content text-that-needs-wrapping">
        <div class="modal-p-title">
          <span>Provide more cross-comparable audio!</span>
        </div>
        <div class="modal-p-desc">
          <p>You already have the maximum number of ATK Songs activated in your Player. To activate more, either de-activate an ATK Song, or contact <a href="mailto:sales@audiotestkitchen.com">sales@audiotestkitchen.com</a> to increase the number of ATK Songs in your subscription.</p>
          <p>Providing a wide range of vocals, instruments, and mixes to compare can help your customer really get to know your products and the differences between them.</p>
        </div>
      </div>
      <div class="modal-p-img">
        <img src="@/assets/images/permissions/sources.png" alt="" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flagVisible: Boolean
  },
  emits: ['closeModal'],
  data: function () {
    return {
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>
